import { computed } from "vue"
import { defineStore, storeToRefs } from "pinia"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager"
import type { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"
import type { Instruction } from "@/models/instruction.model"
import { useAppInstructionStore } from "@/store/app-instructions.store"
import { useInstructionStore } from "@/store/instructions.store"

export const useInstructionFeedbacksActivitiesStore = defineStore(
  "instructionFeedbacksActivitiesStore",
  () => {
    const appInstructionStore = useAppInstructionStore()
    const { instructions: appInstructions } = storeToRefs(appInstructionStore)

    const instructionStore = useInstructionStore()
    const { instructions: planningInstructions } = storeToRefs(instructionStore)

    const appInstructionFeedbackActivities = computed(() => {
      const instructionFeedbackActivities = []
      for (const instruction of appInstructions.value) {
        if (instruction.feedback) {
          instructionFeedbackActivities.push(...instruction.feedback.instructionFeedbackActivities)
        }
      }
      return instructionFeedbackActivities
    })

    const planningInstructionFeedbackActivities = computed(() => {
      const instructionFeedbackActivities = []
      for (const instruction of planningInstructions.value) {
        if (instruction.feedback) {
          instructionFeedbackActivities.push(...instruction.feedback.instructionFeedbackActivities)
        }
      }
      return instructionFeedbackActivities
    })

    const {
      pushToRelatedObjects: pushToRelatedAppInstructions,
      removeFromRelatedObjects: removeFromRelatedAppInstructions
    } = useRelatedObjectsManager(
      appInstructions,
      (instructionFeedbackActivity: InstructionFeedbackActivity) =>
        instructionFeedbackActivity.instructionFeedback,
      (instruction: Instruction) => instruction.feedback?.id,
      (instruction: Instruction) => instruction.feedback?.instructionFeedbackActivities
    )

    const {
      pushToRelatedObjects: pushToRelatedPlanningInstructions,
      removeFromRelatedObjects: removeFromRelatedPlanningInstructions
    } = useRelatedObjectsManager(
      planningInstructions,
      (instructionFeedbackActivity: InstructionFeedbackActivity) =>
        instructionFeedbackActivity.instructionFeedback,
      (instruction: Instruction) => instruction.feedback?.id,
      (instruction: Instruction) => instruction.feedback?.instructionFeedbackActivities
    )

    return {
      appInstructionFeedbackActivities,
      planningInstructionFeedbackActivities,
      pushToRelatedAppInstructions,
      removeFromRelatedAppInstructions,
      pushToRelatedPlanningInstructions,
      removeFromRelatedPlanningInstructions
    }
  }
)
